import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormInput,
  CFormSwitch,
  CLoadingButton,
  CRow,
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import Loader from 'src/components/Loader'
import FixtureService from 'src/service/FixtureService'

const FixtureSetting = () => {
  const [defaultAttrForManageScore, setDefaultAttrForManageScore] = useState([])
  const [defaultAttrForCompletedScore, setDefaultAttrForCompletedScore] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingForCompletedFixture, setIsLoadingForCompletedFixture] = useState(true)
  const getAttributeDataForManageScore = () => {
    FixtureService.getFixtureAttributes(1).then((res) => {
      if (res.status === 200) {
        setIsLoading(false)
        setDefaultAttrForManageScore(res.data) // Initialize default attributes from API
      }
    })
  }
  const getAttributeDataForCompletedScore = () => {
    FixtureService.getFixtureAttributes(2).then((res) => {
      if (res.status === 200) {
        setIsLoadingForCompletedFixture(false)
        setDefaultAttrForCompletedScore(res.data) // Initialize default attributes from API
      }
    })
  }
  const [mergedAttributes, setMergedAttributes] = useState([])

  useEffect(() => {
    Promise.all([
      FixtureService.getFixtureAttributes(1),
      FixtureService.getFixtureAttributes(2),
    ]).then(([manageRes, completedRes]) => {
      if (manageRes.status === 200 && completedRes.status === 200) {
        const manage = manageRes.data
        const completed = completedRes.data

        const merged = manage.map((m) => {
          const findCompleted = completed.find((c) => c.attribute_key === m.attribute_key)

          return {
            attribute_key: m.attribute_key,
            label: m.label,
            full_name: m.full_name,

            // enable flags
            manage_enabled: m.is_enabled,
            completed_enabled: findCompleted ? findCompleted.is_enabled : 0,
          }
        })

        setMergedAttributes(merged)

        setIsLoading(false)
        setIsLoadingForCompletedFixture(false)
      }
    })
  }, [])

  const handleSwitchChange = (attributeKey, isChecked, type) => {
    // 1. update mergedAttributes instantly
    setMergedAttributes((prev) =>
      prev.map((attr) =>
        attr.attribute_key === attributeKey ? { ...attr, manage_enabled: isChecked ? 1 : 0 } : attr,
      ),
    )

    // 2. backend update
    const data = { attribute_key: attributeKey, is_enabled: isChecked, type }
    FixtureService.updateAttributeState(data)
      .then((res) => {
        ToastComponent(res.message, 'success')
      })
      .catch(console.error)
  }

  const handleSwitchChangeForCompletedScore = (attributeKey, isChecked, type) => {
    // 1. update mergedAttributes instantly
    setMergedAttributes((prev) =>
      prev.map((attr) =>
        attr.attribute_key === attributeKey
          ? { ...attr, completed_enabled: isChecked ? 1 : 0 }
          : attr,
      ),
    )

    // 2. backend update
    const data = { attribute_key: attributeKey, is_enabled: isChecked, type }
    FixtureService.updateAttributeState(data)
      .then((res) => {
        ToastComponent(res.message, 'success')
      })
      .catch(console.error)
  }

  const attributeNames = [
    { key: 'rs', label: 'RS' },
    { key: 'bf', label: 'BF' },
    { key: 'fours', label: '4S' },
    { key: 'sixes', label: '6S' },
    { key: 'overs', label: 'OVRS' },
    { key: 'mdns', label: 'MDNS' },
    { key: 'run', label: 'RG' },
    { key: 'wks', label: 'WKTS' },
    { key: 'cs', label: 'CS' },
    { key: 'cwks', label: 'CWK' },
    { key: 'sts', label: 'ST' },
    { key: 'rods', label: 'ROD' },
    { key: 'roas', label: 'ROA' },
    { key: 'dks', label: 'DKS' },
    { key: 'hattrick', label: 'HT' },
    { key: 'no', label: 'NO' },
    { key: 'hwot', label: 'HWOT' },
    { key: 'wb', label: 'WB' },
    { key: 'wct', label: 'WCT' },
    { key: 'wcwk', label: 'WCWK' },
    { key: 'wlbw', label: 'WLBW' },
    { key: 'wst', label: 'WST' },
    { key: 'whw', label: 'WHW' },
    { key: 'dotp', label: 'DOTP' },
    { key: 'dotb', label: 'DOTB' },
  ]

  return (
    <>
      <CRow>
        <CAccordion activeItemKey={1} alwaysOpen>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              <strong>Manage Scores - Scorecard View</strong>
            </CAccordionHeader>
            <CAccordionBody>
              {isLoading ? (
                <Loader />
              ) : (
                <CTable className="main-table table innertable">
                  <CTableHead>
                    <CTableRow>
                      <CTableHeaderCell scope="col">Name</CTableHeaderCell>
                      <CTableHeaderCell scope="col">Full Name</CTableHeaderCell>
                      <CTableHeaderCell scope="col">Manage Scores</CTableHeaderCell>
                      <CTableHeaderCell scope="col">Completed Fixtures</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {mergedAttributes.map((attr, index) => (
                      <tr key={index}>
                        <td>{attr.label}</td>
                        <td>{attr.full_name}</td>
                        <td>
                          <CFormSwitch
                            id={`switch-live-${attr.attribute_key}`}
                            checked={attr.manage_enabled === 1}
                            onChange={(e) =>
                              handleSwitchChange(attr.attribute_key, e.target.checked ? 1 : 0, 1)
                            }
                          />
                        </td>
                        <td>
                          <CFormSwitch
                            id={`switch-completed-${attr.attribute_key}`}
                            checked={attr.completed_enabled === 1}
                            onChange={(e) =>
                              handleSwitchChangeForCompletedScore(
                                attr.attribute_key,
                                e.target.checked ? 1 : 0,
                                2,
                              )
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </CTableBody>
                </CTable>
              )}
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>
    </>
  )
}

export default FixtureSetting
